module.exports = __webpack_public_path__ + "713051dc100f61c8152d72a90abe734c.png";